import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from "prop-types";
import { _delete, get, postWithHeaders, postWithHeadersResponse, put, putWithHeadersResponse } from "../../../server/actions";
import Form from 'react-validation/build/form';
import Input from 'react-validation/build/input';
import Button from 'react-validation/build/button';
import { required, email, zipValidation, isNumeric, phoneNo } from '../../../server/validationMethods'
import NotificationSystem from 'react-notification-system';
import { BeatLoader } from 'react-spinners';
import { _addNotification, _addNotificationError, numberOnly } from "../../../server/util";


const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)'
    }
};
const districts = {
    "firstName": "",
    "lastName": "",
    "mobileNo": "",
    "role": "ROLE_DISTRICT",
    "isActive": true,
    "username": "",
    "isPrimaryUser": true,
    "isVerified": false
}
class DistrictRecord extends Component {
    constructor() {
        super();
        this.state = {
            loading: false,
            districtId: 0,
            countryListDetails: [],
            countryData: [],
            timeZones: [],
            isdCode: '',
            districtDetails: {
                "name": "",
                "addressLine1": "",
                "addressLine2": "",
                "city": "",
                "country": "",
                "state": "",
                "zip": "",
                "timezone": '',
                "faxNumber": '',
                "contactNumber": '',
                "isActive": true,
                "loggedUser": sessionStorage.getItem('loggedInUserInfo'),
                "districtUsers": [JSON.parse(JSON.stringify(districts))]
            },
            "deletePrimaryModal": false,
            "selectedPrimaryUserData": {}
        }
        this.getDistrictDetails = this.getDistrictDetails.bind(this);
        this.saveDistrictDetails = this.saveDistrictDetails.bind(this)
        console.log('DistrictDetails::::', this.state.districtDetails);
    }
    componentWillMount = () => {
        const { did } = this.context.router.route.match.params;
        let _districtId = 0;
        try {
            if (parseInt(did) > 0) {
                _districtId = parseInt(did)
            }
        } catch (ex) {
        }
        this.setState({ districtId: _districtId }, () => {
            // if(this.state.catererId>0){
            this.getCountryList();
            //}            
        });
    }

    componentDidMount = () => {
        this._notificationSystem = this.refs.notificationSystem;
    }
    getCountryList() {
        this.setState({ loading: true });
        get('/countryDetails?&access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            let countryList = [];
            data._embedded.countryDetails.forEach(function (val) {
                countryList.push({ text: val.countryCode + ' (' + val.countryName + ')', value: val.countryCode });
            });
            this.setState({ loading: false, countryListDetails: countryList, countryData: data._embedded.countryDetails },
                this.getDistrictDetails(this.state.districtId));
        })
            .catch(
                (error) => {
                    this.setState({ loading: false });
                    console.log('Onboard School response', error)
                }
            )
    }
    getDistrictDetails = (id) => {
        this.setState({ loading: true });
        get('/districts/' + id + '?&access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            let tzList = [];
            let isdCode = '';
            this.state.countryData.filter(item => {
                if (item.countryCode === data.country) {
                    isdCode = item.isdCode;
                    JSON.parse(item.timezoneInfo).forEach(function (val) {
                        tzList.push({ text: val.timezoneName + ' (' + val.timezoneDesc + ')', value: val.timezoneName });
                    })
                }
            });
            data.districts = (data.districts || []).length > 0 ? data.districts : [JSON.parse(JSON.stringify(districts))]
            this.setState({ loading: false, districtDetails: data, timeZones: tzList, isdCode: isdCode });
        })

            .catch(
                (error) => {
                    this.setState({ loading: false });
                    console.log('Onboard School response', error)
                }
            )
    }

    saveDistrictDetails = (e) => {
        e.preventDefault();
        let _district = JSON.parse(JSON.stringify(this.state.districtDetails));
        this.setState({ loading: true });
        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        };
        _district.id = this.state.districtId;
        console.log("District::::::", JSON.stringify(_district));
        if (this.state.districtId > 0) {
            putWithHeadersResponse(`/${this.state.districtId}/district?access_token=`, JSON.stringify(_district), headers)
                .then((response) => {
                    if (!response.ok) {
                        throw Error(response.statusText);
                    }
                    return response;
                })
                .then((data) => {
                    _addNotification('Successfully updated district data.', this);
                    this.setState({ loading: false });
                    setTimeout(() => {
                        this.context.router.history.push('/superAdmin/districtList')
                    }, 3000);
                    console.log('Access Links Sent', data);
                }).catch(error => {
                    this.setState({ loading: false });
                    //document.getElementById("submit").disabled = false;
                    _addNotificationError('Could not updated district data.', this);
                    console.log('update district response', error)

                });
        }
        else {
            delete _district.id;
            postWithHeaders('/districts?access_token=', JSON.stringify(_district), headers).then((response) => {
                console.log("POST response:::::", response);
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                console.log('response', response);
                //return response.json();
                return response;

            }).then((data) => {
                _addNotification('New District Onboard Successfully.', this);
                this.setState({ loading: false });
                setTimeout(() => {
                    this.context.router.history.push('/superAdmin/districtList')
                }, 3000);
            }).catch(error => {
                this.setState({ loading: false });
                //document.getElementById("submit").disabled = false;
                _addNotificationError('Failed to onboard new District.', this);
                console.log('Add District response', error);

            });
        }
    }
    selectCountry = (e) => {
        let tzList = [];
        let isdCode = '';
        this.state.countryData.filter(item => {
            if (item.countryCode === e.target.value) {
                isdCode = item.isdCode;
                JSON.parse(item.timezoneInfo).forEach(function (val) {
                    tzList.push({ text: val.timezoneName + ' (' + val.timezoneDesc + ')', value: val.timezoneName });
                })
            }
        });
        let data = this.state.districtDetails;
        data.country = e.target.value;
        data.countryCode = e.target.value;
        data.timeZone = '';
        this.setState({ districtDetails: data, timeZones: tzList, isdCode: isdCode });
    }
    selectTimeZone = (e) => {
        let data = this.state.districtDetails;
        data.timezone = e.target.value;
        this.setState({ districtDetails: data });
    }
    uniqueEmail = (value, index) => {
        let res = undefined;
        let _userEmailErrors = this.state.userEmailErrors;
        if (value.length > 4) {
            get('/emailValidate?email=' + value + '&type=&access_token=').then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response.json();
            }).then(data => {
                if (data.statusCode == 200) {
                    delete _userEmailErrors[index];
                } else {
                    _userEmailErrors[index] = data.statusMessage
                    //res=(<span className="text-danger">{data.statusMessage}</span>);            
                }
            }).catch(
                (error) => {
                    _userEmailErrors[index] = 'This email id already used for one of the user!!'
                    //res=(<span className="text-danger">This email id already used for one of the admin user!!</span>);                    
                }
            );
        } else {
            delete _userEmailErrors[index];
        }
        this.setState({ userEmailErrors: _userEmailErrors })
    }
    deleteprimaryUser = () => {
        let count = 0
        this.state.userInfo.forEach((item) => {
            if (item.isPrimaryUser) {
                count++
            }

        })
        if (count === 1) {
            _addNotificationError("Sorry, you can't able to delete this user...", this);
            this.setState({ deletePrimaryModal: false, selectedPrimaryUserData: {} })
        } else {
            // delete call
            this.deleteUser()
        }
    }
    deleteUser = () => {
        if (this.state.selectedPrimaryUserData.username) {
            this.setState({ loading: true });
            const loggedInUserDetails = sessionStorage.getItem("loggedInUserDetails")
            get('/enableDisableDistrictUser?UserName=' + this.state.selectedPrimaryUserData.username + '&activeStatus=false&loggedUser=' + JSON.parse(loggedInUserDetails).username + '&access_token=').then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                console.log('response', response);
                return response;
            }).then(data => {
                this.setState({
                    loading: false,
                    deletePrimaryModal: false
                });
                _addNotification('Successfully deactivated admin.', this);
                //this.getSchoolList();

                //this.getDataSyncFieldMap();
                window.location.reload();
                console.log('Access Links Sent', data);
            })
                .catch(
                    (error) => {
                        this.setState({
                            loading: false,
                            deletePrimaryModal: false
                        });
                        _addNotificationError('Deactivation failed. Please try again later.', this);
                        console.log('Send Notification Links response', error)
                    }
                )
        }

    }
    render() {
        return (
            <div>
                <NotificationSystem ref="notificationSystem" />
                <div className='sweet-loading' style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000   ' }}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>
                <div className="container">
                    <div className="sectionTitle">
                        <h2>
                            <span>{this.state.districtId > 0 ? 'Update District' : 'Onboard - New District'}</span>
                        </h2>
                    </div>
                    <div className="row">
                        <div className="col-md-6 col-md-offset-3 col-sm-6 col-sm-offset-3 col-xs-12">
                            <div className="panel panel-info">
                                <div className="panel-heading text-center">
                                    <h3 className="panel-title"><i
                                        className="" /> District
                                    </h3>
                                </div>

                                <div className="panel-body panel-body-onboard">
                                    <Form ref={c => { this.form = c }} onSubmit={this.saveDistrictDetails}>
                                        <div>
                                            <div className="form-group"
                                                id="districtName">
                                                <label className="control-label" htmlFor="districtName">District Name*</label>
                                                <Input name="name" className="form-control border-color-1 rounded"
                                                    value={this.state.districtDetails.name}
                                                    validations={[required]} requiredmsg={'Please enter district name'}
                                                    onChange={(e) => {
                                                        let district = this.state.districtDetails;
                                                        district['name'] = e.target.value;
                                                        this.setState({ districtDetails: district });
                                                    }} />
                                            </div>
                                            <div className="form-group"
                                                id="addressLine1">
                                                <label className="control-label" htmlFor="addressLine1">Address*</label>
                                                <Input name="addressLine1"
                                                    className="form-control border-color-1 rounded"
                                                    value={this.state.districtDetails.addressLine1}
                                                    validations={[required]} requiredmsg={'Please enter district address'}
                                                    onChange={(e) => {
                                                        let district = this.state.districtDetails;
                                                        district['addressLine1'] = e.target.value;
                                                        this.setState({ districtDetails: district });
                                                    }} />
                                            </div>
                                            <div className="form-group"
                                                id="city">
                                                <label className="control-label" htmlFor="city">City(District)*</label>
                                                <Input name="city"
                                                    className="form-control border-color-1 rounded" validations={[required]} requiredmsg={'Please enter city'}
                                                    value={this.state.districtDetails.city} onChange={(e) => {
                                                        let district = this.state.districtDetails;
                                                        district['city'] = e.target.value;
                                                        this.setState({ districtDetails: district });
                                                    }} />
                                            </div>
                                            <div className="form-group"
                                                id="state">
                                                <label className="control-label" htmlFor="state">State*</label>
                                                <Input name="state"
                                                    className="form-control border-color-1 rounded"
                                                    value={this.state.districtDetails.state}
                                                    validations={[required]} requiredmsg={'Please enter state'}
                                                    onChange={(e) => {
                                                        let district = this.state.districtDetails;
                                                        district['state'] = e.target.value;
                                                        this.setState({ districtDetails: district });
                                                    }} />
                                            </div>
                                            <div className="form-group" id="country">
                                                <label className="control-label" htmlFor="country">Country ISO Code*</label>
                                                <Input list="countrylist" name="country" id="country" validations={[required]} requiredmsg={'Please select country code'}
                                                    onChange={e => this.selectCountry(e)}
                                                    value={this.state.districtDetails.country}
                                                    className="form-control border-color-1 rounded"
                                                    placeholder="Search..." autoComplete="off"
                                                />
                                                <datalist id="countrylist">
                                                    {this.state.countryListDetails.map((country, key) =>
                                                        <option data-id={key}
                                                            value={country.value}>{country.text}</option>
                                                    )}
                                                </datalist>
                                            </div>
                                            <div className="form-group"
                                                id="districtZip">
                                                <label className="control-label" htmlFor="zip">Zip*</label>
                                                <Input name="zip" validations={[required, zipValidation]} requiredmsg={'Please enter zip code'}
                                                    className="form-control border-color-1 rounded"
                                                    value={this.state.districtDetails.zip}
                                                    onChange={(e) => {
                                                        let district = this.state.districtDetails;
                                                        district['zip'] = e.target.value;
                                                        this.setState({ districtDetails: district });
                                                    }} />
                                            </div>
                                            <div className="form-group">
                                                <label className="control-label" htmlFor="contactNumber">Phone*</label>
                                                <div className="input-group">
                                                    <span className="input-group-addon">{this.state.isdCode}</span>
                                                    <Input type="text" style={{ zIndex: '1' }}
                                                        name="contactNumber"
                                                        className="form-control"
                                                        value={(this.state.districtDetails.contactNumber || '').slice(-10)}
                                                        id="contactNumber"
                                                        validations={[required, isNumeric, phoneNo]} requiredmsg={'Please enter phone no'}
                                                        placeholder={'Mobile Number'}
                                                        onChange={e => {
                                                            let district = this.state.districtDetails;
                                                            district['contactNumber'] = e.target.value;
                                                            this.setState({ districtDetails: district });
                                                        }}
                                                        maxLength={10}
                                                        onKeyPress={numberOnly} />
                                                </div>
                                            </div>
                                            <div className="form-group" id="timezone">
                                                <label className="control-label" htmlFor="country">Time zone*</label>
                                                <Input list="timeZonelist" name="timezone" id="timezone"
                                                    validations={[required]} requiredmsg={'Please select time zone'}
                                                    onChange={e => this.selectTimeZone(e)}
                                                    value={this.state.districtDetails.timezone}
                                                    className="form-control border-color-1 rounded"
                                                    placeholder="Search..." autoComplete="off"
                                                    disabled={this.state.timeZones.length > 0 ? false : true} />
                                                <datalist id="timeZonelist">
                                                    {this.state.timeZones.map((zone, key) =>
                                                        <option data-id={key}
                                                            value={zone.value}>{zone.text}</option>
                                                    )}
                                                </datalist>
                                            </div>
                                            <div className="form-group">
                                                <label className="control-label" htmlFor="country">Fax*</label>
                                                <div className="input-group">
                                                    <span className="input-group-addon">{this.state.isdCode}</span>
                                                    <Input type="text" style={{ zIndex: '1' }}
                                                        name="faxNumber"
                                                        className="form-control"
                                                        value={(this.state.districtDetails.faxNumber || '').slice(-10)}
                                                        id="faxNumber"
                                                        validations={[isNumeric, phoneNo]}
                                                        placeholder={'Fax Number'}
                                                        onChange={e => {
                                                            let district = this.state.districtDetails;
                                                            district['faxNumber'] = e.target.value;
                                                            this.setState({ districtDetails: district });
                                                        }}
                                                        maxLength={10}
                                                        onKeyPress={numberOnly} />
                                                </div>
                                            </div>
                                            <div className="form-group col-sm-12">
                                                <h2 style={{
                                                    width: '100%',
                                                    textAlign: 'center',
                                                    borderBottom: '1px solid #000',
                                                    lineHeight: '0.1em',
                                                    margin: '10px 0 20px',
                                                    color: 'gray'
                                                }}>
                                                    <span style={{ background: '#fff', padding: '0 10px' }}
                                                        className="panel-title">Admin</span></h2>
                                            </div>
                                            {this.state.districtDetails.districtUsers.map((user, idx) => {
                                                if (user.isPrimaryUser)
                                                    return (<div>
                                                        <div className="form-group">
                                                            <label className="control-label" htmlFor="country">First
                                                                Name*</label>
                                                            <Input type="text" name="firstName"
                                                                className="form-control border-color-1 rounded" id="fname"
                                                                placeholder="First Name" value={user.firstName}
                                                                validations={[required]} requiredmsg={'Please enter first name'}
                                                                onChange={(e) => {
                                                                    let _districtDetails = this.state.districtDetails;
                                                                    let _users = _districtDetails.districtUsers;
                                                                    _users[idx]['firstName'] = e.target.value
                                                                    _districtDetails.districtUsers = _users;
                                                                    this.setState({ districtDetails: _districtDetails });
                                                                }} />
                                                        </div>
                                                        <div className="form-group">
                                                            <label className="control-label" htmlFor="district">Last
                                                                Name*</label>
                                                            <Input type="text" name="lastName"
                                                                className="form-control border-color-1 rounded" id="lastName"
                                                                placeholder="Last Name" value={user.lastName}
                                                                validations={[required]} requiredmsg={'Please enter last name'}
                                                                onChange={(e) => {
                                                                    let _districtDetails = this.state.districtDetails;
                                                                    let _users = _districtDetails.districtUsers;
                                                                    _users[idx]['lastName'] = e.target.value
                                                                    _districtDetails.districtUsers = _users;
                                                                    this.setState({ districtDetails: _districtDetails });
                                                                }}
                                                            />
                                                        </div>
                                                        <div className="form-group">
                                                            <label className="control-label" htmlFor="country">Phone*</label>
                                                            <div className="input-group">
                                                                <span className="input-group-addon">{this.state.isdCode}</span>
                                                                <Input type="text" style={{ zIndex: '1' }}
                                                                    className="form-control"
                                                                    value={(user.mobileNo || '').slice(-10)}
                                                                    id="mobileNo"
                                                                    validations={[required, isNumeric, phoneNo]} requiredmsg={'Please enter phone no'}
                                                                    placeholder={'Mobile Number'}
                                                                    onChange={(e) => {
                                                                        let _districtDetails = this.state.districtDetails;
                                                                        let _users = _districtDetails.districtUsers;
                                                                        _users[idx]['mobileNo'] = e.target.value
                                                                        _districtDetails.districtUsers = _users;
                                                                        this.setState({ districtDetails: _districtDetails });
                                                                    }}
                                                                    maxLength={10}
                                                                    onKeyPress={numberOnly} />
                                                            </div>
                                                        </div>
                                                        {this.state.districtId > 0 ? (<div className="form-group">
                                                            <label className="control-label" htmlFor="username">Email ID*</label>
                                                            <Input type="email" name={'username'} id="username"
                                                                pattern="[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$"
                                                                className="form-control border-color-1 rounded"
                                                                validations={[required, email]} requiredmsg={'Please enter email id'}
                                                                placeholder="Email ID" value={user.username} readOnly={true}
                                                                //    onBlur={(e)=>{
                                                                //     this.uniqueEmail(e.target.value)
                                                                // }}
                                                                onChange={(e) => {
                                                                    let _districtDetails = this.state.districtDetails;
                                                                    let _users = _districtDetails.districtUsers;
                                                                    _users[idx]['username'] = e.target.value
                                                                    _districtDetails.districtUsers = _users;
                                                                    this.setState({ districtDetails: _districtDetails });
                                                                }}
                                                            />
                                                            <span id={user.username} className="validateMessage"></span>
                                                        </div>) : (<div className="form-group">
                                                            <label className="control-label" htmlFor="username">Email ID*</label>
                                                            <Input type="email" name={'username'} id="username"
                                                                pattern="[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$"
                                                                className="form-control border-color-1 rounded"
                                                                validations={[required, email]} requiredmsg={'Please enter email id'}
                                                                placeholder="Email ID" value={user.username}
                                                                onChange={(e) => {
                                                                    let _districtDetails = this.state.districtDetails;
                                                                    let _users = _districtDetails.districtUsers;
                                                                    _users[idx]['username'] = e.target.value
                                                                    _districtDetails.districtUsers = _users;
                                                                    this.setState({ districtDetails: _districtDetails });
                                                                }}
                                                            />
                                                            <span id={user.username} className="validateMessage"></span>
                                                        </div>)}
                                                        <div className="checkbox col-sm-12" style={{ marginTop: '10px', padding: '0' }}>
                                                            <label style={{ fontWeight: '700' }}>
                                                                <input type="checkbox" className="radio" checked={user.isActive}
                                                                    name="isActive" onChange={(e) => {
                                                                        let _districtDetails = this.state.districtDetails;
                                                                        let _users = _districtDetails.districtUsers;
                                                                        _users[idx]['isActive'] = e.target.checked ? true : false
                                                                        _districtDetails.districtUsers = _users;
                                                                        this.setState({ districtDetails: _districtDetails });
                                                                    }} />Is Active </label>
                                                        </div>
                                                    </div>)
                                            })}


                                            <div className="col-md-12 col-sm-12 col-xs-12">

                                                <button className="pull-left btn btn-primary btn-sm" type="button" onClick={() => {
                                                    this.context.router.history.push('/SuperAdmin/districtList')
                                                }}
                                                    style={{ margin: 0, fontSize: 14 }}>Back
                                                </button>

                                                <Button className="btn btn-success btn-sm pull-right"
                                                    type="Submit" style={{ margin: 0, fontSize: 14 }}
                                                >Finish
                                                </Button>
                                            </div>

                                        </div>
                                    </Form>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </div>
        );
    }
}
DistrictRecord.contextTypes = {
    router: PropTypes.object.isRequired
}

export default DistrictRecord;


// WEBPACK FOOTER //
// ./src/components/SuperAdmin/district/districtRecord.jsx